import React, { useState } from 'react';

const Placeholder = ({ label, className = '' }) => (
  <div
    className={`flex items-center justify-center bg-gradient-to-br from-brown/20 via-burnt/20 to-brown/10 dark:from-dark-surface dark:via-burnt/10 dark:to-dark-bg ${className}`}
  >
    <span className="text-burnt/60 font-heading font-bold text-sm uppercase tracking-wider text-center px-4">
      {label}
    </span>
  </div>
);

export const ImageWithFallback = ({
  src,
  alt,
  className = '',
  placeholderLabel = 'Imagem',
  fallbackSources = [],
}) => {
  const sources = [src, ...fallbackSources].filter(Boolean);
  const [sourceIndex, setSourceIndex] = useState(0);

  const currentSrc = sources[sourceIndex];
  const hasError = sourceIndex >= sources.length;

  if (!currentSrc || hasError) {
    return <Placeholder label={placeholderLabel} className={className} />;
  }

  return (
    <img
      src={currentSrc}
      alt={alt}
      className={className}
      loading="lazy"
      onError={() => setSourceIndex((prev) => prev + 1)}
    />
  );
};

export default ImageWithFallback;
